module.exports = __webpack_public_path__ + "static/media/animacao_paul_standby-nova.bd56b260.gif";